// extracted by mini-css-extract-plugin
export default {"suspense-fallback-spinner":"App_suspense-fallback-spinner__Nf4An","app-root":"App_app-root__D7Cdw"};